// LOCALHOST
export const BASE_URL_SITE = 'http://localhost/saber-do-futuro/ava/site/'
export const BASE_URL_API = 'http://localhost:3333/' // URL API
export const COOKIE_DOMAIN = ''

// PRODUCTION
// export const BASE_URL_SITE = 'https://ava.saberdofuturo.com.br/'
// export const BASE_URL_API = 'https://ava-api.saberdofuturo.com.br/' // URL API
// export const COOKIE_DOMAIN = '.saberdofuturo.com.br'

// BOTHS
export const MINIMUM_VIDEO_PLAYED = 80 // percentage
export const BLOCK_BY_VIDEO_PAYED = true // ativa o bloqueio de aula por tempo assistido